import { createApp, Static } from "vue";
import "./index.css";

import { ServiceSymbol, Service } from "./service";

import FeatureToggle from "./components/utility/FeatureToggle.vue"

import Graz from "./components/utility/TenantTemplates/Graz.vue";
import Vorarlberg from "./components/utility/TenantTemplates/Vorarlberg.vue";

import router from "./router";

import Loader from "./components/Loader.vue";
import ModalDialog from "./components/parts/ModalDialog.vue";
import App from "./App.vue";

import directives  from './components/directives'
import { StaticDataRepository, StaticDataSymbol } from "./composables/StaticDataRepository";
import { Services, ServicesSymbol } from "./services";
import { Identity, IdentitySymbol } from "./features/identity";
import { FeedbackHandler, FeedbackSymbol } from "./composables/Feedback";

import * as Sentry from "@sentry/vue";

const identity = new Identity();

const services = new Services(
  import.meta.env.VITE_API_HOST || '',
  identity?.Token);

const service = new Service(import.meta.env.VITE_API_HOST || '');
const staticDataRepository = new StaticDataRepository(service);

await services.Features.LoadActiveFeatures();

const feedbackHandler = new FeedbackHandler(services.Datenjahr);


const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://a1dc12c29f3c040f2b2bf1ff7169ae13@o4509434300596224.ingest.de.sentry.io/4509434314489936",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_ENVIRONMENT != ''
});

app.component('Loader', Loader);

directives(app);

app.use(router)


app.provide(IdentitySymbol, identity);
app.provide(ServicesSymbol, services);
app.provide(FeedbackSymbol, feedbackHandler);

app.component('FeatureToggle', FeatureToggle);


app.component('Graz', Graz);
app.component('Vorarlberg', Vorarlberg);

app.provide(ServiceSymbol, service);
app.provide(StaticDataSymbol, staticDataRepository);
app.component('ModalDialog', ModalDialog);

router.isReady().then(() => {
  app.mount("#app");
});
